// extracted by mini-css-extract-plugin
export default {"unifiedCard":"AdminCallList_unifiedCard__0PIIn"};